import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors";
import imgModify from "../../assets/images/icones/modify.png";

import ModalProjet from "../Modales/ModalProjet";
import sommeMontants from "../../utils/functions/sommeMontants";

const ProjetsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    h1 {
        padding: 10px 80px;
    }
`;

const StyledFilters = styled.div`
    height: 80px;
    display: flex;
    justify-content: space-start;
    gap: 15px;
    align-items: center;
    background-color: ${colors.dark};
    padding: 10px;
    margin: 10px 0 20px 0;
    color: white;
    label {
        color: ${colors.primary};
        font-size: 1.2rem;
        padding-left: 3px;
    }
    h2 {
        padding-left: 20px;
        font-weight: bold;
        margin-right: 20px;
    }
    select {
        /* width: 200px; */
        padding: 0 5px;
        border-radius: 5px;
    }
    .ordreTri {
        padding-left: 20px;
        width: 80px;
        text-align: center;
    }
`;

const StyledTable = styled.table`
    width: 100%;
    margin: 40px 0;
`;
const FirstTr = styled.tr`
    background-color: ${colors.dark};
    color: white;
    font-size: 1.5rem;
    height: 60px;
    th {
        padding: 3px 5px;
    }
`;
const LastTr = styled.tr`
    background-color: ${colors.dark};
    color: white;
    font-size: 1.3rem;
    height: 40px;

    td {
        padding: 3px 5px;
    }
    text-align: center;
`;

const StyledTr = styled.tr`
    &:nth-child(odd) {
        background-color: #f0f8ff;
    }
    height: 40px;
    text-align: center;
    .vign {
        border-radius: 8px;
        margin: 5px;
        padding: 5px;
        width: 100%;
    }
    .OG {
        background-color: #e6d8f0;
    }
    .PR {
        background-color: #b3d9ff;
    }
    .PA {
        background-color: #d1f0d1;
    }

    .statut {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .contact {
        display: flex;
        justify-content: space-between;
        padding-left: 15px;
    }

    .dateEtape {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button {
        border: none;
        margin-right: 10px;
        background-color: transparent;
        cursor: pointer;
    }

    button.nomProjet {
        border: 2px solid #e0e0e0;
        background-color: transparent;
        color: ${colors.secondary};
        border-radius: 30px;
        padding: 8px 12px;
        margin: 1px;
        font-weight: bold;
        &:hover {
            text-decoration: underline;
        }
    }

    button.PO {
        
        background-color: transparent;
        color: ${colors.secondary};
        
        padding: 8px 12px;
        margin: 1px;
        font-weight: bold;
        &:hover {
            text-decoration: underline;
        }
    }

    /* code pour changer l'icone native des navigateurs pour l'input date.... from ChatGPT  */
    .custom-date-input {
        position: relative;
        display: inline-block;
    }

    .custom-date-input input[type="date"] {
        appearance: none; /* Supprime le style natif */
        -webkit-appearance: none; /* Supprime le style natif sur Safari */
        position: relative;
        padding: 10px;
        padding-right: 40px; /* Espace pour l'icône */
        font-size: 16px;
        border: none;
        background-color: transparent;
    }

    .custom-date-input input[type="date"]::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 50%;
        right: 10px; /* Positionner à droite */
        transform: translateY(-50%);
        cursor: pointer;
        opacity: 0; /* Rendre l'icône native invisible */
        z-index: 2; /* S'assurer qu'elle est cliquable */
    }

    .custom-date-input .icon {
        position: absolute;
        top: 50%;
        right: 10px; /* Positionner à droite */
        transform: translateY(-50%);
        pointer-events: none; /* Empêcher les clics sur l'icône */
        color: #999;
        font-size: 20px;
    }

    .custom-date-input input[type="date"].empty {
        color: transparent; /* Cache le texte de l'input lorsqu'il est vide */
    }

    .custom-date-input .placeholder {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        color: black;
        font-size: 16px;
        pointer-events: none; /* Ne pas interférer avec les clics */
    }
`;

const Projets = ({
    dataObjects,
    setSelectedTriProjets,
    selectedTriProjets,
    setDirectionTriProjets,
    directionTriProjets,
    setRefreshFlag,
    handleProjet,
}) => {
    const renderStatutCell = (dataObject) => {
        const statutLabels = {
            OG: { className: "OG", label: "Offre gagnée" },
            PR: { className: "PR", label: "Phase de réalisation" },
            PA: { className: "PA", label: "Projet achevé" },
        };

        const content = statutLabels[dataObject.statut];
        if (!content) return null;

        return (
            <td className="statut">
                <p className={`vign ${content.className}`}>{content.label}</p>
                <button
                    onClick={() => offreModal("updateStatut", dataObject)}
                    id={dataObject.id}
                >
                    <img
                        className="modify"
                        src={imgModify}
                        alt="modification"
                        height="26px"
                    />
                </button>
            </td>
        );
    };
    // gestion des modales de changement des projets (Statut, dateEtape, )
    //booléen d'affichage des modales
    const [showModalUpdateRef, setShowModalUpdateRef] = useState(false);
    const [showModalUpdateStatut, setShowModalUpdateStatut] = useState(false);
    //    const [showModalUpdateDateEtape, setShowModalUpdateDateEtape] = useState(false);
    const [projet, setProjet] = useState("");
    const [listContact, setListContact] = useState([[]]);

    const offreModal = (content, projet) => {
        const actions = {
            updateReferent: () => prepareUpdateRef(projet.id),
            updateStatut: () => setShowModalUpdateStatut(true),
        };
        // Exécuter l'action correspondant à "content", s'il existe ?. : opérateur d'accès optionnel , n'agit que si cela existe
        actions[content]?.();
        setProjet(projet);
    };
    // fonction qui prépare le fetch des contacts puis l'ouverture de la modale pour updateRef (modale de mise à jour du contact référent de l'offre)
    const prepareUpdateRef = async (id) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/admin/offre/fetchContactByOffre`,
                {
                    method: "POST",
                    credentials: "include",
                    body: JSON.stringify({
                        projet_id: id,
                    }),
                }
            );
            const data = await response.json();
            // console.log(deletedEntreprise.status);

            if (!response.ok) {
                console.error("Erreur de chargement des contacts" + data);
            } else {
                setListContact(data["content"]);
                setShowModalUpdateRef(true);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des contacts", error);
        }
    };

    const handleChange = (event) => {
        if (event.target.name === "triOffres") {
            setSelectedTriProjets(event.target.value);
        } else if (event.target.name === "direction") {
            setDirectionTriProjets(event.target.value);
        }
        // setRefreshFlag((prev)=>!prev);
    };

    const handleCloseModale = (content) => {
        const actions = {
            updateReferent: () => setShowModalUpdateRef(false),
            updateStatut: () => setShowModalUpdateStatut(false),
        };
        // Exécuter l'action correspondant à "content", s'il existe ?. : opérateur d'accès optionnel , n'agit que si cela existe
        actions[content]?.();
        setProjet("");
    };

    const handlePO = async(id, nom)=>{
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/documents/downloadFile`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        docId: id,
                    }),
                }
            );

            if (!response.ok) {
                console.error("Erreur lors du téléchargement du document");
            } else {
                const blob = await response.blob(); // Convertir la réponse en blob
                const url = window.URL.createObjectURL(blob); // Créer un lien vers le blob
                const link = document.createElement("a"); // Créer un élément <a>
                link.href = url;
                link.setAttribute("download", nom); // Nom du fichier à télécharger
                document.body.appendChild(link);
                link.click(); // Simuler le clic
                // Nettoyage après le téléchargement
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url); // Libérer l'URL du blob // Supprimer le lien après le téléchargement
            }
        } catch (error) {
            console.error("Erreur lors du téléchargement", error);
        }
    }
    

    return (
        <>
            <ProjetsContainer>
                <h1>Tableau des projets</h1>
                <StyledFilters>
                    <h2>Trier par</h2>
                    <div>
                        <input
                            type="radio"
                            id="entreprise"
                            name="triOffres"
                            value="entreprise"
                            checked={selectedTriProjets === "entreprise"}
                            onChange={handleChange}
                        />
                        <label htmlFor="entreprise">Entreprise</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="nom"
                            name="triOffres"
                            value="nom"
                            checked={selectedTriProjets === "nom"}
                            onChange={handleChange}
                        />
                        <label htmlFor="nom_offre">Nom du projet</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="date_creation"
                            name="triOffres"
                            value="date_creation"
                            checked={selectedTriProjets === "date_creation"}
                            onChange={handleChange}
                        />

                        <label htmlFor="dateCreation">Date de création</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="date_etape"
                            name="triOffres"
                            value="date_etape"
                            checked={selectedTriProjets === "date_etape"}
                            onChange={handleChange}
                        />
                        <label htmlFor="dateEtape">Date Etape</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="statut"
                            name="triOffres"
                            value="statut"
                            checked={selectedTriProjets === "statut"}
                            onChange={handleChange}
                        />
                        <label htmlFor="statut">Statut</label>
                    </div>

                    <div className="ordreTri">
                        <label htmlFor="dateCreation">Sens:</label>
                        <select
                            name="direction"
                            id="direction"
                            onChange={handleChange}
                            value={directionTriProjets}
                        >
                            <option value="ASC">Ascendant</option>
                            <option value="DESC">Descendant</option>
                        </select>
                    </div>
                </StyledFilters>

                <StyledTable>
                    <tbody>
                        <FirstTr>
                            <th>Client</th>
                            <th>Contact référent</th>
                            <th>N° d'offre</th>
                            <th>Nom du projet</th>
                            <th>Montant XOF</th>
                            <th>Montant €</th>
                            <th>P.O.</th>
                            <th>Statut</th>
                        </FirstTr>
                        {dataObjects.map((dataObject, index) => (
                            <StyledTr key={index}>
                                <td>{dataObject.entreprise}</td>
                                <td>
                                    <div className="contact">
                                        <div>
                                            {dataObject.contactSexe === "M"
                                                ? "Mr"
                                                : "Mme"}{" "}
                                            {dataObject.contactNom}{" "}
                                        </div>
                                        <button
                                            onClick={() =>
                                                offreModal(
                                                    "updateReferent",
                                                    dataObject
                                                )
                                            }
                                            id={dataObject.id}
                                        >
                                            {" "}
                                            <img
                                                className="modify"
                                                src={imgModify}
                                                alt="modification"
                                                height="26px"
                                            />
                                        </button>
                                    </div>
                                </td>
                                <td>{dataObject.numeroOffre}</td>
                                <td>
                                    <button
                                        className="nomProjet"
                                        onClick={() =>
                                            handleProjet(dataObject.id)
                                        }
                                    >
                                        {dataObject.nom}
                                    </button>
                                </td>
                                <td>{dataObject.montant}</td>
                                <td>
                                    {Math.round(
                                        dataObject.montant * 0.001524 * 100
                                    ) / 100}
                                </td>
                                {/* Appel de la fonction pour générer le contenu du statut */}
                                <td>
                                    {Array.isArray(dataObject.PO_id) &&
                                        dataObject.PO_id.length > 0 &&
                                        dataObject.PO_id.map((id, index) => {
                                            return (
                                                <button
                                                    key={id}
                                                    className="PO"
                                                    onClick={() =>
                                                        handlePO(
                                                            id,
                                                            `PO${index + 1} ` +
                                                                dataObject.nom
                                                        )
                                                    }
                                                >
                                                    {`PO${index + 1}`}
                                                </button>
                                            );
                                        })}
                                </td>
                                {renderStatutCell(dataObject)}
                            </StyledTr>
                        ))}
                        <LastTr>
                            <td colSpan={4}>Totaux</td>
                            <td>{sommeMontants(dataObjects)} XOF</td>
                            <td>
                                {Math.round(
                                    sommeMontants(dataObjects) * 0.001524 * 100
                                ) / 100}{" "}
                                €
                            </td>
                            <td colSpan={2}></td>
                        </LastTr>
                    </tbody>
                </StyledTable>
            </ProjetsContainer>
            {showModalUpdateRef && (
                <ModalProjet
                    content="updateReferent"
                    type="projet"
                    handleClose={(content) => handleCloseModale(content)}
                    listContact={listContact}
                    dataProjet={projet}
                    setRefreshFlag={setRefreshFlag}
                ></ModalProjet>
            )}
            {showModalUpdateStatut && (
                <ModalProjet
                    content="updateStatut"
                    type="projet"
                    handleClose={(content) => handleCloseModale(content)}
                    dataProjet={projet}
                    setRefreshFlag={setRefreshFlag}
                ></ModalProjet>
            )}
        </>
    );
};

export default Projets;
